export default function(state={}, action){
  switch(action.type) {
    case 'GET_WORKOUTS':
      return {...state, saveWorkout: null, deleteWorkouts:null, saveToProd:null, workouts:action.paylod}
    case 'SAVE_WORKOUT':
      return {...state, deleteWorkouts:null, saveWorkout:action.paylod}
    case 'DELETE_WORKOUTS':
      return {...state, saveWorkout: null, deleteWorkouts:action.paylod}
    case 'GET_TEMP_WORKOUTS':
      return {...state, saveTempWorkout: null, deleteTempWorkouts:null, tempWorkouts:action.paylod}
    case 'SAVE_TEMP_WORKOUT':
      return {...state, deleteTempWorkouts:null, saveTempWorkout:action.paylod}
    case 'DELETE_TEMP_WORKOUTS':
      return {...state, saveTempWorkout: null, deleteTempWorkouts:action.paylod}
    case 'GET_EXERCISE_MAPPING': 
      return {...state,saveExerciseMapping:null,deleteExerciseMapping:null, exerciseMapping:action.paylod}
    case 'SAVE_EXERCISE_MAPPING': 
      return {...state, saveExerciseMapping:action.paylod}
    case 'DELETE_EXERCISE_MAPPING': 
      return {...state, deleteExerciseMapping:action.paylod}
    case 'SAVE_TO_PROD':
      return {...state, saveToProd:action.paylod}
    case 'SAVE_EXERCISE_MAPPING_TO_PROD': 
      return {...state, saveExerciseMappingToProd:action.paylod}
    case 'WORKOUT_VIDEOS': 
      return {...state, videos:action.paylod}
    case 'GET_SKILLS':
      return {...state,saveSkill:null, skills:action.paylod}
    case 'SAVE_SKILL':
      return {...state, saveSkill:action.paylod}
    default:
      return state;
  }
}